/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { createEnum, EnumSet, WithOptimisticLock } from '@gh/core-data';

export const HelpRequestType = createEnum('HELPER_BUG_REQUEST_TYPE', {
  Request: 'REQUEST',
  SystemBug: 'SYSTEM_BUG',
});
export type HelpRequestType = EnumSet<typeof HelpRequestType>;

export const HelpRequestPriority = createEnum('BUG_PRIORITY', {
  Blocked: 'BLOCKER',
  Critical: 'CRITICAL',
  Normal: 'NORMAL',
  Minor: 'MINOR',
});
export type HelpRequestPriority = EnumSet<typeof HelpRequestPriority>;

export type HelpRequestAttachmentDto = {
  body: string;
  name: string;
  contentType: string;
  encode?: string;
};

export type HelpRequestDto = WithOptimisticLock<{
  subject: string;
  description: string;
  attachments: HelpRequestAttachmentDto[];
  priority: HelpRequestPriority;
  login: string;
  buildNumber: string;
  date: Date;
  mode?: HelpRequestType;
  officeName?: string;
  masterZoneName?: string;
  attachScreenshot?: boolean;
  etag?: string;
}>;
